/**
 * Welche Fassung trägt ein Service-Worker? (29.10.2026, Martin: „Neue Version“ blieb nach dem Neuladen stehen)
 *
 * Ursache des hängenden Knopfs: Jeder Bau schreibt eine neue sw.js (die Fassung steckt im Cache-Namen). Der Weg des Knopfs
 * ohne wartenden Worker lud nach `registration.update()` neu, BEVOR der frische Worker fertig installiert war. Die neue Seite
 * kam mit der richtigen Fassung — der Worker war dann „installiert und wartend“, die Seite hielt das für ein Update und zeigte
 * den Knopf wieder. Wartet ein Worker mit DERSELBEN Fassung wie die Seite, ist nichts neu: er wird still aktiviert.
 */

/** So lange darf der Worker für seine Antwort brauchen (er schläft evtl. erst auf). */
export const WORKER_VERSION_FRIST_MS = 1500;

/** Die Fassung des Workers, oder null (keine Antwort, Fehler). Wirft nie. */
export function frageWorkerVersion(worker: Pick<ServiceWorker, "postMessage">, frist = WORKER_VERSION_FRIST_MS): Promise<string | null> {
  return new Promise((fertig) => {
    let kanal: MessageChannel;
    try {
      kanal = new MessageChannel();
    } catch {
      fertig(null);
      return;
    }
    const uhr = globalThis.setTimeout(() => {
      kanal.port1.close();
      fertig(null);
    }, frist);
    kanal.port1.onmessage = (ev: MessageEvent) => {
      globalThis.clearTimeout(uhr);
      kanal.port1.close();
      fertig(typeof ev.data === "string" && ev.data ? ev.data : null);
    };
    try {
      worker.postMessage({ type: "version" }, [kanal.port2]);
    } catch {
      globalThis.clearTimeout(uhr);
      fertig(null);
    }
  });
}

/** Gleiche Fassung heißt: der wartende Worker bringt nichts Neues. Unbekannt (null) heißt: vorsichtshalber neu. */
export function gleicheFassung(worker: string | null, seite: string): boolean {
  return Boolean(worker) && Boolean(seite) && worker === seite;
}
